import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const usePodIP = () => {
    const [searchParams] = useSearchParams();
    const [podIP, setPodIP] = useState(null);

    useEffect(() => {
        // Check if pod_ip is in URL parameters (initial load)
        const urlPodIP = searchParams.get('pod_ip');

        if (urlPodIP) {
            // Store in session storage and set state
            sessionStorage.setItem('pod_ip', urlPodIP);
            setPodIP(urlPodIP);
        } else {
            // Try to get from session storage
            const storedPodIP = sessionStorage.getItem('pod_ip');
            if (storedPodIP) {
                setPodIP(storedPodIP);
            }
        }
    }, [searchParams]);

    /**
     * Clear the stored pod_ip
     */
    const clearPodIP = () => {
        sessionStorage.removeItem('pod_ip');
        setPodIP(null);
    };

    return {
        podIP,
        hasPodIP: !!podIP,
        clearPodIP
    };
};
